export default "__VITE_ASSET__7277e2dc__"